import React from "react";
import { Image, ImageProps } from "../../components/Image/Image";
import { IconLinksCards, Props as IconLinksCardProps } from "../../components/IconLinksCards/IconLinksCards";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { LinksProps } from "../../components/Links";
import { ParagraphCard } from "../../components/ParagraphCard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";

export interface GasLandingPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  serviceCards?: IconLinksCardProps;
  images?: ImageProps[];
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const GasLandingPage: React.FC<GasLandingPageProps> = ({ seo, pageTitle, paragraphs, serviceCards, images, linksList, faqs }) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && linksList && linksList[0] && <ParagraphCard paragraph={paragraphs[0]} linkList={linksList[0]} />}
      {serviceCards && <IconLinksCards {...serviceCards} />}
      {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      {images && images[0] && <Image {...images[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
